import useRegListeners from '~/composables/forms/useRegListeners';
import type { TTemplateName } from '~/interfaces/form/formBuilder';

const useFormListeners = (templateName: TTemplateName, form: Ref) => {
  switch (templateName) {
    case 'registration':
    case 'complete registration':
      useRegListeners(form);
      break;
    default:
      break;
  }
};

export default useFormListeners;
